import styles from './style.css';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import { getBrowser } from '../utils';

class AdPlaying extends Component {
    static propTypes = {
        adTime: PropTypes.number,
    };
    constructor(props) {
        super(props);
        this.state = {
            isRender: true,
            videoTipVolumeMute: false,
            // videoTipVolumeMute: getBrowser() === 'Safari' || getBrowser() === 'Chrome',
        };
    }
    componentDidMount() {
        this.advolume = this.refs['advolume'];
        this.adlink = this.refs['videoTipLink'];
        this.advip = this.refs['videoTipVip'];
        this.adsecond = this.refs['videoTipNumber'];
        // 整个区域
        this.adlink2 = this.refs['videoAdLink'];
    }
    hide() {
        this.setState({
            showItem: false,
        });
    }
    show() {
        this.setState({
            showItem: true,
        });
    }

    destory() {
        this.setState({
            isRender: false,
        });
    }

    adVideoMutedPlay = () => {
        this.setState({
            videoTipVolumeMute: true,
        });
    };

    videoTipVolumeMuteToggle = () => {
        this.setState({
            videoTipVolumeMute: !this.state.videoTipVolumeMute,
        });
    };
    render() {
        const { isRender, showItem, videoTipVolumeMute } = this.state;
        const { adTime } = this.props;
        const children = isRender ? (
            <div className={styles.videoad} style={{ display: showItem ? 'block' : 'none' }} id="js_videoad_container">
                <div className={styles.videoTipTop}>
                    <span
                        className={styles.videoTipNumber}
                        ref="videoTipNumber"
                        data-tag="adcount"
                        id="js_video_tip_number">
                        {adTime}s
                    </span>
                    <a href="javascript:void(0)" className={styles.videoTipVip} ref="videoTipVip" data-tag="advip">
                        会员可去掉广告
                    </a>
                    <a
                        href="javascript:void(0)"
                        className={videoTipVolumeMute ? styles.videoTipVolumeMute : styles.videoTipVolume}
                        ref="advolume"
                        data-tag="advolume"
                        onClick={this.jingyin}
                    />
                </div>
                <div className={styles.videoTipBottom}>
                    <a
                        href="javascript:void(0)"
                        target="_blank"
                        className={styles.videoTipLink}
                        ref="videoTipLink"
                        data-tag="adlink">
                        <span ref="tipLinkL" className={styles.videoTipLinkL}>
                            查看广告详情
                        </span>
                        <span ref="tipLinkR" className={styles.videoTipLinkR} />
                    </a>
                </div>
                <div className={styles.videoAdLink} ref="videoAdLink">
                    <a href="javascript:void(0)" target="_blank" data-tag="adlink" />
                </div>
            </div>
        ) : null;

        return children;
    }
}

export default AdPlaying;
